var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBpArrowExpandBpLightGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "arrow-expand",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "#99CC00",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:0px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.769043,27.507812H4.492188v-10.276855c0-.441895-.35791-.799805-.799805-.799805s-.799805.35791-.799805.799805v11.07666c0,.441895.35791.799805.799805.799805h11.07666c.441895,0,.799805-.35791.799805-.799805s-.35791-.799805-.799805-.799805Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.307617,2.892578h-11.07666c-.441895,0-.799805.35791-.799805.799805s.35791.799805.799805.799805h10.276855v10.276855c0,.441895.35791.799805.799805.799805s.799805-.35791.799805-.799805V3.692383c0-.441895-.35791-.799805-.799805-.799805Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBpArrowExpandBpLightGreen);
export default __webpack_public_path__ + "static/media/bp-arrow-expand-bp-light-green.9c5dd116933ba89a870341e045ca42ce.svg";
export { ForwardRef as ReactComponent };